import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import ambiente from '../../config/ambienteConfig';
// import PesosForm from './PesosForm';
// import PesosRow from './PesosRow';

class Pesos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            peso_tesouro_direto: 0,
			peso_renda_fixa: 0,
			peso_acoes: 0,
			peso_fii: 0,
            peso_outros: 0,
            soma: 0,
        };
    }

    componentDidMount = async () => {
        try {
            const res = await axios.get(`${ambiente.dev.server}/pesos`);
            if(res.data) {
                this.setState({ 
                    peso_acoes: res.data.peso_acoes * 100,
                    peso_renda_fixa: res.data.peso_renda_fixa * 100,
                    peso_tesouro_direto: res.data.peso_tesouro_direto * 100,
                    peso_fii: res.data.peso_fii * 100,
                    peso_outros: res.data.peso_outros * 100,
                 });
            }
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleSave = async () => {
        try {
            const peso_acoes =  this.state.peso_acoes / 100;
            const peso_renda_fixa =  this.state.peso_renda_fixa / 100;
            const peso_tesouro_direto =  this.state.peso_tesouro_direto / 100;
            const peso_fii =  this.state.peso_fii / 100;
            const peso_outros =  this.state.peso_outros / 100;
            await axios.post(`${ambiente.dev.server}/pesos`, {peso_acoes, peso_fii, peso_outros, peso_renda_fixa, peso_tesouro_direto});
            this.props.exibirMensagem('yay', 'Pesos atualizados com sucesso');
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    render() {
        return (
            <div>
                <h2>Pesos</h2>
                <div className="form-group">
                    <label htmlFor="peso_tesouro_direto">Tesouro Direto</label>
                    <input className="form-control" placeholder="Tesouro Direto" name="peso_tesouro_direto" autoFocus type="number" step="0.01"
                        value={this.state.peso_tesouro_direto} onChange={evt => this.setState({ peso_tesouro_direto: evt.target.value})}/>
                </div>
                <div className="form-group">
                    <label htmlFor="peso_renda_fixa">Renda Fixa</label>
                    <input className="form-control" placeholder="Renda Fixa" name="peso_renda_fixa" type="number" step="0.01"
                        value={this.state.peso_renda_fixa} onChange={evt => this.setState({ peso_renda_fixa: evt.target.value})}/>
                </div>
                <div className="form-group">
                    <label htmlFor="peso_acoes">Ações</label>
                    <input className="form-control" placeholder="Ações" name="peso_acoes" type="number" step="0.01"
                        value={this.state.peso_acoes} onChange={evt => this.setState({ peso_acoes: evt.target.value})}/>
                </div>
                <div className="form-group">
                    <label htmlFor="peso_fii">FIIs</label>
                    <input className="form-control" placeholder="FIIs" name="peso_fii" type="number" step="0.01"
                        value={this.state.peso_fii} onChange={evt => this.setState({ peso_fii: evt.target.value})}/>
                </div>
                <div className="form-group">
                    <label htmlFor="peso_outros">Outros</label>
                    <input className="form-control" placeholder="Outros" name="peso_outros" type="number" step="0.01"
                        value={this.state.peso_outros} onChange={evt => this.setState({ peso_outros: evt.target.value})}/>
                </div>
                <div className="form-group">
                    <label htmlFor="somatoria">Somatória</label>
                    <input className="form-control" placeholder="Soma" name="somatoria" disabled
                        value={parseFloat(this.state.peso_acoes) + parseFloat(this.state.peso_fii) + parseFloat(this.state.peso_outros) 
                                + parseFloat(this.state.peso_renda_fixa) + parseFloat(this.state.peso_tesouro_direto)}/>
                </div>
                <button type="button" className="btn btn-primary btn-block" onClick={this.handleSave}>
                    Salvar
                </button>
            </div>
        );
    }
}

Pesos.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
  };
  
  function mapStateToProps(state) {
    return {};
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Pesos);
  


// WEBPACK FOOTER //
// ./src/components/pesos/Pesos.js